import '../svg-icon/svg-icon';

import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement('number-input')
export class NumberInput extends LitElement {

    // Props

    @property({ type: Boolean, reflect: true })
    disabled: boolean = false;

    @property({ type: Number })
    value: number = 0;

    @property({ type: Number })
    step: number = 1;

    @property({ type: Number })
    min: number = 0;

    @property({ type: Number })
    max: number = 10;

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('NumberInput');
    }

    // Render

    render() {
        return html`
            <button 
                class="NumberInput-button"
				aria-label="Decrease"
                @click="${ this._decrement }">
                <svg-icon name="minus"></svg-icon>
            </button>
            <input 
                class="NumberInput-field"
                type="number" 
                value="${ this.value }" 
                step="${ this.step }" 
                min="${ this.min }" 
                max="${ this.max }"
            />
            <button 
                class="NumberInput-button"
				aria-label="Increase"
                @click="${ this._increment }">
                <svg-icon name="plus"></svg-icon>
            </button>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Methods

    private _decrement() {
        this.value = Math.max(this.value - 1, this.min);
        const event = new Event('change');
        this.dispatchEvent(event);
    }

    private _increment() {
        this.value = Math.min(this.value + 1, this.max);
        const event = new Event('change');
        this.dispatchEvent(event);
    }

}